// ============================================================================
// REDUCER - visualCircuitReducer.js
// ============================================================================
// ./context/visualCircuit/visualCircuitReducer.js

const visualCircuitReducer = (state, { type, payload }) => {
    switch (type) {
        // Circuit Management
        case 'SET_CIRCUITS':
            return {
                ...state,
                circuits: payload,
                isLoading: false,
                error: null
            };
        
        case 'SET_CURRENT_CIRCUIT':
            return {
                ...state,
                currentCircuit: payload,
                isLoading: false,
                error: null
            };
        
        case 'ADD_CIRCUIT':
            return {
                ...state,
                circuits: [payload, ...state.circuits],
                isLoading: false,
                error: null
            };
        
        case 'UPDATE_CIRCUIT':
            return {
                ...state,
                circuits: state.circuits.map(circuit =>
                    circuit._id === payload._id ? payload : circuit
                ),
                currentCircuit: state.currentCircuit?._id === payload._id 
                    ? payload 
                    : state.currentCircuit,
                isLoading: false,
                error: null
            };
        
        case 'DELETE_CIRCUIT':
            return {
                ...state,
                circuits: state.circuits.filter(circuit => circuit._id !== payload),
                currentCircuit: state.currentCircuit?._id === payload 
                    ? null 
                    : state.currentCircuit,
                isLoading: false,
                error: null
            };

        // Templates
        case 'SET_TEMPLATES':
            return {
                ...state,
                templates: payload,
                isLoading: false,
                error: null
            };

        // Filter-based lists
        case 'SET_STUDENT_CIRCUITS':
            return {
                ...state,
                studentCircuits: payload,
                isLoading: false,
                error: null
            };

        case 'SET_LAB_CIRCUITS':
            return {
                ...state,
                labCircuits: payload,
                isLoading: false,
                error: null
            };

        case 'SET_COURSE_CIRCUITS':
            return {
                ...state,
                courseCircuits: payload,
                isLoading: false,
                error: null
            };

        case 'SET_ENROLLED_USERS':
            return { ...state, enrolledUsers: payload };

        // Statistics
        case 'SET_STATISTICS':
            return {
                ...state,
                statistics: payload,
                isLoading: false,
                error: null
            };

        // Component Operations
        case 'ADD_COMPONENT':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        components: [...state.currentCircuit.components, payload]
                    }
                };
            }
            return state;

        case 'REMOVE_COMPONENT':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        components: state.currentCircuit.components.filter(
                            c => c.instanceId !== payload
                        )
                    }
                };
            }
            return state;

        case 'UPDATE_COMPONENT':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        components: state.currentCircuit.components.map(c =>
                            c.instanceId === payload.instanceId ? payload : c
                        )
                    }
                };
            }
            return state;

        // Connection Operations
        case 'ADD_CONNECTION':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        connections: [...state.currentCircuit.connections, payload]
                    }
                };
            }
            return state;

        case 'REMOVE_CONNECTION':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        connections: state.currentCircuit.connections.filter(
                            c => c.connectionId !== payload
                        )
                    }
                };
            }
            return state;

        case 'UPDATE_CONNECTION':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        connections: state.currentCircuit.connections.map(c =>
                            c.connectionId === payload.connectionId ? payload : c
                        )
                    }
                };
            }
            return state;

        // Validation
        case 'SET_VALIDATION_RESULT':
            return {
                ...state,
                validationResult: payload,
                isLoading: false,  // ✅ This is critical!
                error: null
            };

        // Validation Error
        case 'SET_VALIDATION_ERRORS':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        validationErrors: payload,
                        isValid: payload.filter(e => e.type === 'error').length === 0
                    },
                    isLoading: false,  // ✅ ADD THIS
                    error: null
                };
            }
            return {
                ...state,
                isLoading: false,  // ✅ AND THIS (for when no currentCircuit)
                error: null
            };

        // Canvas Settings
        case 'UPDATE_CANVAS_SETTINGS':
            if (state.currentCircuit) {
                return {
                    ...state,
                    currentCircuit: {
                        ...state.currentCircuit,
                        canvasSettings: {
                            ...state.currentCircuit.canvasSettings,
                            ...payload
                        }
                    }
                };
            }
            return state;

        // Sync to Simulator
        case 'SYNC_SUCCESS':
            return {
                ...state,
                isLoading: false,
                error: null
            };
            
        // Loading & Error
        case 'SET_LOADING':
            return {
                ...state,
                isLoading: payload
            };

        case 'SET_ERROR':
            return {
                ...state,
                error: payload,
                isLoading: false
            };

        case 'CLEAR_ERROR':
            return {
                ...state,
                error: null
            };

        case 'CLEAR_VISUAL_CIRCUIT_DATA':
            return {
                circuits: [],
                currentCircuit: null,
                templates: [],
                studentCircuits: [],
                labCircuits: [],
                courseCircuits: [],
                statistics: null,
                isLoading: false,
                error: null
            };

        default:
            return state;
    }
};

export default visualCircuitReducer;